import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import React, { useCallback } from 'react';

import AppTopBar from './components/AppTopBar';
import Login from './pages/Login';
import HomePage from './pages/HomePage';
import GuidelinesPage from './pages/guidelines/GuidelinesPage';
import MyPocsPage from './pages/MyPocsPage';
import AllPocsPage from './pages/AllPocsPage';
import TaskListTable from './pages/TaskListTable';
import PlayGroundPage from './pages/PlaygroundPage';
import PocTypePage from './pages/initiation/PocTypePage';
import BusinessJustificationPage from './pages/initiation/BusinessJustificationPage';
import ScorecardPage from './pages/initiation/ScorecardPage';
import ScorecardResultPage from './pages/initiation/ScorecardResultPage';
import FacilitationSupportPage from './pages/initiation/FacilitationSupportPage';
import InitiationReviewPage from './pages/initiation/InitiationReviewPage';
import SuccessCriteriaPage from './pages/preparation/SuccessCriteriaPage';
import PocEnvironmentPage from './pages/preparation/PocEnvironmentPage';
import NdaAssessmentPage from './pages/preparation/NdaAssessmentPage';
import DataProtectionAssessmentPage from './pages/preparation/DataProtectionAssessmentPage';
import ItSecurityAssessmentPage from './pages/preparation/ItSecurityAssessmentPage';
import LegalAssessmentPage from './pages/preparation/LegalAssessmentPage';
import ProcurementAssessmentPage from './pages/preparation/ProcurementAssessmentPage';
import PreparationReviewPage from './pages/preparation/PreparationReviewPage';
import RunningPhasePage from './pages/running/RunningPhasePage';
import EvaluationPhasePage from './pages/evaluation/EvaluationPhasePage';
import EvaluationCompletePage from './pages/evaluation/EvaluationCompletePage';

const AppRouter: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();

  const protect = useCallback(
    (page: React.ReactNode) => (isAuthenticated ? page : <Login />),
    [isAuthenticated]
  );

  return (
    <Router>
      <div className="app-shell">
        {isAuthenticated ? <AppTopBar /> : null}
        <div className="app-shell__page">
          <Routes>
        {/* Home — after login */}
        <Route path="/" element={protect(<HomePage />)} />

        {/* PoC shell routes — cards on the home page link here */}
        <Route path="/pocs/new" element={protect(<PocTypePage />)} />
        <Route
          path="/pocs/new/business-justification"
          element={protect(<BusinessJustificationPage />)}
        />
        <Route
          path="/pocs/new/scorecard"
          element={protect(<ScorecardPage />)}
        />
        <Route
          path="/pocs/new/scorecard/result"
          element={protect(<ScorecardResultPage />)}
        />
        <Route
          path="/pocs/new/facilitation"
          element={protect(<FacilitationSupportPage />)}
        />
        <Route
          path="/pocs/new/review"
          element={protect(<InitiationReviewPage />)}
        />
        <Route
          path="/pocs/new/preparation/success-criteria"
          element={protect(<SuccessCriteriaPage />)}
        />
        <Route
          path="/pocs/new/preparation/environment"
          element={protect(<PocEnvironmentPage />)}
        />
        <Route
          path="/pocs/new/preparation/nda"
          element={protect(<NdaAssessmentPage />)}
        />
        <Route
          path="/pocs/new/preparation/data-protection"
          element={protect(<DataProtectionAssessmentPage />)}
        />
        <Route
          path="/pocs/new/preparation/it-security"
          element={protect(<ItSecurityAssessmentPage />)}
        />
        <Route
          path="/pocs/new/preparation/legal"
          element={protect(<LegalAssessmentPage />)}
        />
        <Route
          path="/pocs/new/preparation/procurement"
          element={protect(<ProcurementAssessmentPage />)}
        />
        <Route
          path="/pocs/new/preparation/review"
          element={protect(<PreparationReviewPage />)}
        />
        <Route
          path="/pocs/new/running/workspace"
          element={protect(<RunningPhasePage />)}
        />
        <Route
          path="/pocs/new/evaluation/workspace"
          element={protect(<EvaluationPhasePage />)}
        />
        <Route
          path="/pocs/new/evaluation/complete"
          element={protect(<EvaluationCompletePage />)}
        />
        <Route path="/my-pocs" element={protect(<MyPocsPage />)} />
        <Route path="/all-pocs" element={protect(<AllPocsPage />)} />
        <Route path="/guidebook" element={protect(<GuidelinesPage />)} />

        {/* Old hackathon screens — keep for now, optional */}
        <Route path="/task-list" element={protect(<TaskListTable />)} />
        <Route path="/navigation" element={<PlayGroundPage />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default AppRouter;
